var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag thread-tag",class:("thread-tag--" + (_vm.threadState.toLowerCase())),attrs:{"title":_vm.threadState}})}
var staticRenderFns = []

export { render, staticRenderFns }